// @flow
import * as React from 'react';

export const EVENT_TYPES = {
  open: 'open',
  exit: 'exit',
  success: 'success',
  error: 'error',
};

export type TEventTypes = $Keys<typeof EVENT_TYPES>;

export type TEventPayload = {};

export type TEventDispatch = (type: TEventTypes, payload: TEventPayload, cb?: () => void) => void;

export type TEventManagerProps = {
  dispatchEvent: TEventDispatch,
};

export default function withEventManager(Component: any): (props: any) => React.Node {
  return function (props: any): React.Node {
    const dispatchEvent = (type: TEventTypes, payload: TEventPayload, cb?: () => void) => {
      const event_channel = new URL(window.location.href).searchParams.get('event_channel') || 'redirect';

      if (event_channel === 'message') window.parent.postMessage({ type, payload }, '*');
      else {
        const url = new URL(`methodlink://${type}`);
        // $FlowFixMe
        for (const [key ,value] of Object.entries(payload)) url.searchParams.append(key, JSON.stringify(value));
        setTimeout(() => window.location = url.href);
      }

      if (cb) setTimeout(() => cb(), 100);
    };

    return (
      <Component {...props} dispatchEvent={dispatchEvent} />
    );
  }
}
